import Data1 from "./data1";
import Data2 from "./data2";

const termsData = [Data1, Data2];
export default termsData;
